  <template>
    <v-card width="280" height="330" :class="cardClass">
      <v-card-title primary-title :class="titleClass">
        <slot name="header"></slot>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <slot name="content"></slot>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="mr-2 ml-4 mb-1">
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </template>

<script>
export default {
  name: 'parking-card-template',
  props: {
    space: {
      type: String
    },
    isFree: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cardClass: function () {
      const css = ['ma-2']
      if (this.isFree) {
        css.push('outlined')
      }
      return css
    },
    titleClass: function () {
      const css = ['pb-2 pt-2']
      if (this.isFree) {
        css.push('')
      } else {
        css.push('primary')
      }
      return css
    }
  }
}
</script>

  <style scoped>
  </style>
